import { useEffect, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Wrapper } from "../components/layout/wrapper";
import { IconFileTypePdf } from "@tabler/icons-react";
import RatioImage from "../components/medias/ratio-image";
import EquipmentResume from "../components/equipment/equipment-resume";
import { useWishlist } from "../contexts/wishlist";

import "./wishlist.scss";
import { LocaleLink } from "@ct-react/locale";
import { buildArticleUrl } from "@shared/url";
import SeoMetas from "../components/layout/seo-metas";

const transDefs = defineMessages({
  main_title: { id: "wishlist.main-title", defaultMessage: "Liste d'envies" },
  download: { id: "wishlist.download-wishlist", defaultMessage: "Télécharger ma liste" },
  empty: { id: "wishlist.empty", defaultMessage: "Vous n'avez aucun bien dans votre liste d'envies pour le moment." },
})

const Wishlist = () => {
  const intl = useIntl();
  const { wishlist, removeById } = useWishlist();

  const handleRemoveItem = (e:any) => {
    removeById(e.currentTarget.id)
  };

  return (
    <Wrapper.Centered>
      <SeoMetas title={intl.formatMessage(transDefs.main_title)} />
      <meta name="robots" content="noindex" />
      <h1>{intl.formatMessage(transDefs.main_title)}</h1>
      <ul className="wishlist">
          {wishlist.length < 1 &&
            <li><div className="empty">{intl.formatMessage(transDefs.empty)}</div></li>
          }
          {wishlist.map((item:any) => {
              return(
                  <li key={item.id}>
                      <div className='image'>
                          <RatioImage source={item.images[0].assets} />
                      </div>
                      <div className="resume">
                        <h3>{item.title.value}</h3>
                        <EquipmentResume data={item}/>
                      </div>
                      <LocaleLink to={buildArticleUrl(item)}></LocaleLink>
                      <button id={item.id} className='delete-product' onClick={handleRemoveItem}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="22px" viewBox="0 0 640 640">
                              <path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/>
                          </svg>
                      </button>
                  </li>
              );
          })}
      </ul>
      <button className='btn primary print-list with-icon' onClick={() => window.print()}>
        <span className="txt">
          <IconFileTypePdf/>
          {intl.formatMessage(transDefs.download)}
        </span>
      </button>
    </Wrapper.Centered>);

};

export default Wishlist;
